import { useForm } from "react-hook-form";
import { Checkbox, FieldError, Grid, H2, Stack } from "atoms";
import {
  useUpdateProductOptions,
  type UpdateProductOptionsReq,
} from "../../api/useUpdateProductOptions";
import type { StepProps } from "../../types";
import { ProductWizardStep } from "../ProductWizardStep";
import { ArtPrintPreview } from "../ArtPrintPreview";
// import { WizardStepOption } from "../WizardStepOption";

function StepArtPrintOptions({ dispatch, state, moveBack }: StepProps) {
  const { isLoading, mutate } = useUpdateProductOptions(state.product.id);

  const {
    register,
    formState: { errors },
    getValues,
    handleSubmit,
  } = useForm<UpdateProductOptionsReq>({
    defaultValues: {
      productOptions: state.product.options,
    },
  });

  // NOTE: This step is required to ALWAYS submit on hitting the next button or else the generated
  // images based on the asset and options will not be attached to each variant
  const onSubmit = handleSubmit((formData) =>
    mutate(formData, {
      onSuccess: () => dispatch({ type: "moveNext" }),
    }),
  );

  const createValidator = (index: number) => () => {
    const vals = getValues("productOptions")[index]?.values ?? [];
    return vals.length >= 1;
  };

  return (
    <ProductWizardStep
      stepTitle="Product Options"
      state={state}
      moveBack={moveBack}
      nextStep={onSubmit}
      nextStepDisabled={isLoading}
    >
      <Stack gap="lg">
        {state.productTemplate.options.map(({ key, values }, optIndex) => (
          <Stack key={key}>
            <H2 size="md" textTransform="none">
              {key}
            </H2>

            <Grid>
              {values.map((value, valIndex) => (
                <div key={value}>
                  <Checkbox
                    label={
                      key !== "Size" ? (
                        value
                      ) : (
                        <ArtPrintPreview
                          src={state.product.assetUrl}
                          size={value}
                          index={valIndex}
                          totalPreviews={values.length}
                        />
                      )
                    }
                    value={value}
                    {...register(`productOptions.${optIndex}.values`, {
                      validate: createValidator(optIndex),
                    })}
                  />
                </div>
              ))}
            </Grid>

            {errors.productOptions?.[optIndex] && (
              <FieldError>
                You need to select at least one value for this option.
              </FieldError>
            )}
          </Stack>
        ))}
      </Stack>
    </ProductWizardStep>
  );
}

StepArtPrintOptions.displayName = "Options";

export { StepArtPrintOptions };
